/* RK Mega Menu - hover/focus open of full-width Graff-style panels.
   Panels (.rk-mega[data-rk-mega-panel="handle"]) are matched to nav triggers
   ([data-rk-mega="handle"]). Desktop only; mobile uses the drawer. */
(function () {
  function init() {
    var panels = document.querySelectorAll('.rk-mega');
    if (!panels.length) return;
    var triggers = document.querySelectorAll('[data-rk-mega]');
    if (!triggers.length) return;
    var header =
      document.querySelector('.header-wrapper') ||
      document.querySelector('.section-header') ||
      document.querySelector('.header');
    var openPanel = null;
    var openTrigger = null;
    var closeTimer = null;

    function clearActive() {
      triggers.forEach(function (t) { t.classList.remove('is-mega-open'); });
    }

    function topPos() {
      if (header) return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      return 110;
    }
    function panelFor(h) {
      return document.querySelector('.rk-mega[data-rk-mega-panel="' + h + '"]');
    }
    function contentHeight(p) {
      var inner = p.querySelector('.rk-mega__inner');
      return inner ? Math.ceil(inner.getBoundingClientRect().height) : 600;
    }
    /* Mega-panel banners are held in data-rk-mega-* and become real requests only on
       the first open. Runs before the height measurement below so the reserved boxes
       are already correct (width/height are on the img, so layout does not shift). */
    var megaHydrated = false;
    function hydrateMega() {
      if (megaHydrated) return;
      megaHydrated = true;
      document.querySelectorAll('[data-rk-mega-src]').forEach(function (img) {
        var sizes = img.getAttribute('data-rk-mega-sizes');
        var srcset = img.getAttribute('data-rk-mega-srcset');
        if (sizes) img.setAttribute('sizes', sizes);
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', img.getAttribute('data-rk-mega-src'));
      });
    }

    function openP(p, trigger) {
      hydrateMega();
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openPanel && openPanel !== p) {
        openPanel.classList.remove('is-open');
        openPanel.setAttribute('aria-hidden', 'true');
      }
      p.style.setProperty('--rk-mega-top', topPos() + 'px');
      // Animate to the exact content height (like Graff) so the reveal is smooth, not snappy.
      p.style.setProperty('--rk-mega-h', contentHeight(p) + 'px');
      p.classList.add('is-open');
      p.setAttribute('aria-hidden', 'false');
      openPanel = p;
      // Keep the top-nav item highlighted while its panel is open (until you leave
      // the menu or hover a different item) - matches Graff.
      clearActive();
      if (trigger) { trigger.classList.add('is-mega-open'); openTrigger = trigger; }
    }
    function closeNow() {
      if (openPanel) {
        openPanel.classList.remove('is-open');
        openPanel.setAttribute('aria-hidden', 'true');
        openPanel = null;
      }
      clearActive();
      openTrigger = null;
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeNow, 140);
    }

    /* TOUCH (iPad, desktop layout at 990px+): there is no hover. Safari usually turns the
       first tap into a mouseenter and swallows the click, but that is a heuristic, and
       nothing closed the panel again except tapping on something that happened to fire
       mouseleave. Made explicit for touch only: the first tap on an item opens its panel
       (the link is not followed), a second tap follows the link, a tap anywhere outside
       the menu closes it. Mouse and keyboard behaviour are unchanged. */
    var touchWasOpen = false;
    var lastPointer = '';
    triggers.forEach(function (t) {
      var h = t.getAttribute('data-rk-mega');
      var p = panelFor(h);
      if (!p) return;
      t.classList.add('rk-has-mega');
      t.addEventListener('mouseenter', function () { openP(p, t); });
      t.addEventListener('mouseleave', scheduleClose);
      t.addEventListener('focusin', function () { openP(p, t); });
      t.addEventListener('pointerdown', function (e) {
        lastPointer = e.pointerType;
        touchWasOpen = openPanel === p;
      });
      t.addEventListener('click', function (e) {
        if (lastPointer !== 'touch' || touchWasOpen) return;
        e.preventDefault();
        openP(p, t);
      });
    });
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || !openPanel) return;
      var el = e.target;
      if (el && el.closest && (el.closest('.rk-mega') || el.closest('[data-rk-mega]'))) return;
      closeNow();
    }, { passive: true });
    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      p.addEventListener('mouseleave', scheduleClose);
    });
    window.addEventListener('scroll', function () {
      if (openPanel) openPanel.style.setProperty('--rk-mega-top', topPos() + 'px');
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNow();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && (e.target.querySelector('[data-rk-mega]') || e.target.querySelector('[data-rk-mm]'))) init(); });
})();
